// const landing_slider = document.querySelector(".rn-landing-slider");

// if (landing_slider) {
//   const swiper = new Swiper(landing_slider, {
//     effect: "cards",
//     grabCursor: true,
//     initialSlide: Math.floor(landing_slider.querySelectorAll(".swiper-slide").length / 2), // Start from the center slide
//     cardsEffect: {
//       perSlideOffset: 0, // Remove slide offset
//       perSlideRotate: 0, // Remove slide rotation
//     },
//   });

//   const applyBlurEffect = () => {
//     const slides = landing_slider.querySelectorAll(".swiper-slide");
//     slides.forEach((slide, index) => {
//       const anchor = slide.querySelector('a'); // Corrected selector

//       if (index === swiper.activeIndex) {
//         slide.style.filter = "none";
//         if (anchor) anchor.style.transform = 'scale(0.9)';
//         slide.style.transform = 'rotateY(0)'; // Reset tilt for active slide
//       } else {
//         slide.style.filter = "blur(5px)";
//         slide.style.transform = 'rotateY(0)'; // Reset tilt for non-active slides
//         if (anchor) anchor.style.transform = 'scale(1)';
//       }
//     });
//   };

//   applyBlurEffect();
//   swiper.on('slideChange', applyBlurEffect);
// }



const consistent_slider = document.querySelector(".rn-consistent-slider");

if (consistent_slider) {
  new Splide(consistent_slider, {
    type: "loop",
    drag: "free",
    focus: "center",
    perPage: 1,
    arrows: false,
    pagination: false,
    autoScroll: {
      speed: 1,
    },
  }).mount(window.splide.Extensions);
}
